import React from 'react';
import classnames from 'classnames';
import type { ICategoryBoxProps } from '../IComponent';
import AnimateLink from '@/basic/AnimateLink';
import '../index.less';
import { NewLink } from '@/basic/NewLink';

const CategoryBox: React.FC<ICategoryBoxProps> = (props) => {

    const {
        image,
        link,
        screenWidth,
        description,
        title,
        note,
        name
    } = props;

    return (
        <div
            // style={ props.isWebView ? { minHeight: '164px' } : undefined }
            className={ classnames('recommend_list_item') }
        >
            { image && screenWidth >= 768 ? (
                <img
                    className={ 'recommend_list_img' }
                    src={ image }
                    alt={ image }
                />
            ) : null }
            <a
                className={ 'category_link' }
                href={ link }
                aria-label={ name }
            >
            </a>
            <div
                // style={ screenWidth < 768 ? { height: '100%', justifyContent: 'center', top: 0 } : undefined }
                className={ 'class_content' }
            >
                <h1>{ title }</h1>
                { screenWidth >= 1280 && <p>{description}</p> }
                {
                    screenWidth >= 768 && (
                        <NewLink
                            href={ link }
                            text={ props.linkText }
                            target={ '_self' }
                        />
                    )
                }
                { screenWidth >= 1280 && <p className={ 'note_p' }>{note}</p> }
            </div>
        </div>
    );
};

export default CategoryBox;
